function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js/instance/some";
import _reduceRightInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce-right";
/* eslint-disable  import/prefer-default-export */
import React from "react";
var isListOfComponents = function isListOfComponents(t) {
  return _Array$isArray(t);
};
var someChangedIdentity = function someChangedIdentity(left, right) {
  return _someInstanceProperty(left).call(left, function (el, i) {
    return el !== right[i];
  });
};
var createComponentFromAs = function createComponentFromAs(as) {
  if (isListOfComponents(as)) {
    var result = _reduceRightInstanceProperty(as).call(as, function (Accumulator, LeftComp) {
      var L = LeftComp;
      var NewComp = function NewComp(props) {
        return /*#__PURE__*/React.createElement(L, _extends({
          as: Accumulator
        }, props));
      };
      return NewComp;
    });
    return result;
  }
  return as;
};
export var useAsProp = function useAsProp(as) {
  var prevAsValueRef = React.useRef(as);
  var prevAsValue = prevAsValueRef.current;
  var toRenderRef = React.useRef(createComponentFromAs(as));
  var arrayChangedSize = _Array$isArray(as) && _Array$isArray(prevAsValue) && (prevAsValue.length !== as.length || someChangedIdentity(prevAsValue, as));
  var propChangedType = _Array$isArray(prevAsValue) !== _Array$isArray(as) && _typeof(prevAsValue) !== _typeof(as);
  if (arrayChangedSize || propChangedType) {
    toRenderRef.current = createComponentFromAs(as);
  }
  prevAsValueRef.current = as;
  return toRenderRef.current;
};